import { GatewayChargingSessionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/charging-sessions/gateway-charging-session.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { EmspBoChargingSessionListLocationOperatorNameCell } from './emsp-bo-charging-session-list-location-operator-name.cell';
import { EmspBoChargingSessionListLocationOperatorNameHeader } from './emsp-bo-charging-session-list-location-operator-name.header';

export const EmspBoChargingSessionListLocationOperatorNameColumn: IdentifiedColumnDef<
  GatewayChargingSessionModel,
  GatewayChargingSessionModel['locationOperatorName']
> = {
  enableSorting: false,
  header: EmspBoChargingSessionListLocationOperatorNameHeader,
  cell: EmspBoChargingSessionListLocationOperatorNameCell,
  meta: { maxWidth: '110px', width: '80px', minWidth: '60px' },
};
